<button class="explorer-icon">
  <i class="fad fa-external-link-square " aria-hidden="true"></i>
</button>